<div mat-dialog-content>
    <div class="flex progress-dialog py-5">
        <div class="shrink-0 w-[50px] md:w-[100px]">
            <mat-spinner [diameter]="innerWidth <= 640 ? 30 : 60" color="red" ></mat-spinner>
        </div>
        <div
            class="flex content-center items-center pl-3 font-bold min-h-[60px] whitespace-pre-wrap"
            [innerHtml]="settings.body | replaceLineBreaks"
        ></div>
    </div>
</div>
